import React from 'react';
import SocialButtons from './socialbuttons';

const {Image} = polyphony.components.generic;

const Footer = ({style, ...props}) => {
    const {footer_text_color: color,
           footer_color: backgroundColor} = polyphony.useState(s => s.colors);
    const {footer_image} = polyphony.useState(s => s.footer);
    return (
        <div className="footer" style={{backgroundColor, color, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', padding: 20, width: '100%', boxSizing: 'border-box', ...style}} {...props}>
            <div style={{marginTop: 'auto'}} />
            <Image lazy media={footer_image} style={{margin: 20}} />
            <div style={{textAlign: 'center', width: '100%', fontSize: 14, fontWeight: 'bold'}}>
                © {(new Date()).getFullYear()} Spark Creative Group, LLC
            </div>
                <SocialButtons twitter facebook instagram linkedin email mapPoint />
        </div>
    );
};

Footer.FOOTER_HEIGHT = 140;

export default Footer;

